import { createFileRoute } from "@tanstack/react-router";
import { SurveyTab } from "@/components/admin/SurveyTab";

export const Route = createFileRoute("/admin/survey")({
  head: () => ({
    meta: [
      { title: "Survey · Admin · INFLOW Marketing" },
      { name: "description", content: "Live view of the funnel qualification survey." },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: () => (
    <div className="space-y-6">
      <div>
        <h1 className="font-serif text-3xl tracking-tight">Survey</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Every question, subheadline, answer option, placeholder and branching rule in the live
          qualification survey. Shared by all split-test variants.
        </p>
      </div>
      <SurveyTab />
    </div>
  ),
});
